import React from 'react';
import { useSelector } from 'react-redux';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  isXRay?: boolean;
};

export const useFBPageUnpublished = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  if (!result || isXRay) {
    return;
  }

  const applicable =
    result.localTests.chatWidgetChannel === 'facebook' ||
    result.localTests.chatWidgetChannel === 'omnichat';

  if (!applicable || !result.backendTests.facebookPageSettings) {
    return;
  }

  if (result.backendTests.facebookPageSettings.isPublished) {
    return {
      type: ChatWidgetTroubleshootingToolResultTypes.FBPageUnpublished,
      result: 'ok',
      description: 'Facebook Page is published.',
    };
  }

  return {
    type: ChatWidgetTroubleshootingToolResultTypes.FBPageUnpublished,
    result: 'error',
    infoTooltip:
      'Please publish your Facebook Page in order to use the Messenger chat widget',
    description: (
      <>
        Facebook Page is not published
        <a
          className="chat-widget-troubleshooting-tool-result__external-link"
          href={`https://www.facebook.com/${result.localTests.fbPageId}/settings/?section=page_visibility&tab=settings`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Edit Page Settings
        </a>
      </>
    ),
  };
};
